import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    linkListGridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    mobileLinkGridList?: GridItemProps;

    mobileLinkList2?: GridItemProps;
    widgetGridMobileContainer?: GridContainerProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            margin: 0 auto !important;
            > div {
                max-width: 100%;
                margin: 0 auto;
                justify-content: center;
                background: ${getColor("primary")};
            }
            @media (max-width: 720px) {
                > div {
                    display: flex;
                    justify-content: center;
                }
            }
        `,
    },
    linkListGridItem: {
        width: [6, 6, 4, 2, 2],
        css: css`
            color: #fff;
            padding: 32px 0px;
            h3 {
                padding: 1rem 0;
            }
            div:first-child {
                line-height: 30px;
            }
            div {
                font-size: 18px;
                font-weight: 400;
                line-height: 25px;
                text-transform: capitalize;
            }
            a[class^="StyledButton"] {
                span {
                    color: #999999;
                    font-size: 14px;
                    line-height: 1.3;
                    &:hover {
                        color: #fff !important;
                    }
                }
            }

            a:focus {
                outline: none !important;
            }

            .LinkListWrapper {
                div:first-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
                .title-wrapper {
                    > span {
                        > span {
                            color: rgb(255, 255, 255) !important;
                        }
                    }
                }
            }

            @media (max-width: 767px) {
                min-width: 100%;
                padding: 15px 25px;
                .LinkListWrapper a {
                    padding: 7px;
                }
                h3 {
                    display: none !important;
                }
                div {
                    > div {
                        > div {
                            font-size: 18px;
                            letter-spacing: 0;
                            line-height: 50px;
                        }
                    }
                }
                a[class^="StyledButton"] {
                    &:hover {
                        span {
                            color: #fff !important;
                        }
                    }
                    span {
                        color: #999999;
                        font-size: 18px;
                        font-weight: 400;
                        &:hover {
                            color: #fff !important;
                        }
                    }
                }
            }
            @media all and (max-width: 1200px) and (min-width: 992px) {
                padding: 15px 6px 15px 1px;
                div:first-child {
                    line-height: 28px;
                    font-size: 17px;
                }
                a[class^="StyledButton"] {
                    span {
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 22px;
                        &:hover {
                            color: #fff !important;
                        }
                    }
                }
            }
        `,
    },
    subscribeGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            color: #fff;
            padding: 13px 0 0 12px;
            h4 {
                padding: 1rem 0 0.6rem 0;
                font-weight: 400;
                font-size: 18px;
                margin-bottom: 0.2rem !important;
            }
            @media all and (max-width: 1200px) and (min-width: 992px) {
                h4 {
                    font-size: 17px;
                }
            }
        `,
    },
    richContentGridItem: {
        width: 12,
        css: css`
            div[class^="ContentWrapper"] {
                padding-top: 18px;
            }
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <>
            <Hidden below="md">
                <GridContainer {...styles.widgetGridContainer}>
                    <GridItem {...styles.linkListGridItem}>
                        <Zone zoneName="LinkList1" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.linkListGridItem}>
                        <Zone zoneName="LinkList2" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.linkListGridItem}>
                        <Zone zoneName="LinkList3" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.subscribeGridItem}>
                        <Zone zoneName="Subscribe" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.richContentGridItem}>
                        <Zone zoneName="RichContent" contentId={id} />
                    </GridItem>
                </GridContainer>
            </Hidden>

            <Hidden above="sm">
                <GridContainer {...styles.widgetGridContainer}>
                    <GridItem {...styles.linkListGridItem}>
                        <Zone zoneName="content" contentId={id} />
                    </GridItem>
                </GridContainer>
            </Hidden>
        </>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
